import { createRouter, createWebHistory } from 'vue-router';
// import courseModuleRoutes from "../modules/course/courseRoutes"
// import courseModuleRoutes from '@/modules/course/courseRoutes';
const DOMAIN_TITLE = 'Student Dashboard';
const router = createRouter({
  history: createWebHistory('/studentapp/'),
  linkActiveClass: 'active',
  routes: [
    {
      name: 'Dashboard',
      path: `/dashboard`,
      component: () => import('../pages/DashboardPage.vue'),
      meta: { title: `${DOMAIN_TITLE} | Course selection` },
    },

    { path: '/:catchAll(.*)', redirect: '/dashboard' },
  ],
});

export default router;

interface Window {
  document: { title: any };
}
interface Window {
  X: number;
}
// Set page titles
router.beforeEach(async (to, from, next) => {
  const pageTitle = to.matched.find((item) => item.meta.title);
  if (pageTitle) (window as any).document.title = pageTitle.meta.title;
  next();
});
